import { _ } from "../polyglot/polyglot.js";
import dialog from "./dialog.js";

/**
 * `removeUserDialog` displays a confirmation popup to the user
 * before removing a user.
 *
 * @param {{}} spec - Parameter object
 * @param {user} spec.user - User to remove
 * @param {{}} my - protected fields holder
 * @return {*} removeUserDialog
 */
function removeUserDialog(spec, my) {
	spec ||= {};
	my ||= {};

	const that = dialog(spec, my);

	const user = spec.user;

	that.onRemoveUser = my.events.createEvent();

	my.title = _("Delete {user}?", { user: user.getName() });

	my.content = function (html) {
		html.render(
			_("Removing {user} can not be undone. Are you sure?", {
				user: user.getName(),
			}),
		);
	};

	my.footer = function (html) {
		html.ul(
			{ class: "list-inline pull-right" },
			html.li(
				html
					.button(
						{ klass: "btn btn-danger" },
						_("Yes, I understand. Remove!"),
					)
					.click(() => {
						that.hide();
						that.onRemoveUser.trigger(user);
					}),
			),
			html.li(
				html
					.button({ klass: "btn primary" }, _("Cancel"))
					.click(that.hide),
			),
		);
	};

	return that;
}

export default removeUserDialog;
